// extracted by mini-css-extract-plugin
export default {"journal-entry-header":"JournalEntryReport_journal-entry-header__bXjIQ","divider":"JournalEntryReport_divider__7HcwD"};